// extracted by mini-css-extract-plugin
export var containerMain = "projectVideo-module--containerMain--17YBV";
export var title = "projectVideo-module--title--19C0f";
export var videoContainer = "projectVideo-module--videoContainer--2cneg";
export var containerBlack = "projectVideo-module--containerBlack--35wQ3";
export var containerWhite = "projectVideo-module--containerWhite--3_Y1l";
export var iframeStyle = "projectVideo-module--iframeStyle--22bWc";